module.exports = __webpack_public_path__ + "img/no-apprentice.3b0cf6ad.png";